export default __webpack_public_path__ + "static/media/OfflineCatalog.486c3655.pdf";